import { Permission } from '@cims-online/shared'
import { EditRowActionOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/row'
import { useCASTypesContext } from '../../../../CASTypesContext'
import { useEditCasTypeMutation } from 'schema'
import { DefaultMutationHookOptions } from 'utils/defaults'
import { simpleEditNotification } from 'hooks/notificationHandler'
import { CreateEditFormItemsValues } from '../../components/CreateEditFormItems/types'
import { CreateEditFormItems } from '../../components/CreateEditFormItems'
import { CASType } from '../../../../CASTypesContext/types'

export function useEdit(): EditRowActionOptions<
  CASType,
  CreateEditFormItemsValues
> {
  const { refetch } = useCASTypesContext()
  const [edit] = useEditCasTypeMutation({
    ...DefaultMutationHookOptions,
    onCompleted: ({
      editCASType: {
        type: { name },
      },
    }) => simpleEditNotification(name),
  })
  return {
    permission: Permission.EditCASType,
    modal: {
      type: 'simple',
      recordName: 'name',
      body: <CreateEditFormItems />,
      initialValues: ({ name, description }) => ({ name, description }),
      onOk: async ({ id, ...type }, { name, description }) => {
        if (type.name !== name || type.description !== description) {
          await edit({
            variables: { editCASTypeInput: { id, name, description } },
          })
          refetch()
        }
      },
    },
  }
}
